/**
 * @Author xyguo
 * @description 新开业培训
 * @Date 2021/3/11
 */
import React from 'react';
import {connect} from 'dva';
import {component_tool, framework_tool, utils_tool} from '@/tool'
import {Form, message, Popconfirm, Spin, Upload} from "antd";
import { WizTableForm } from '@/containers/common';
import RequirementNoticeForm from './requirementNoticeForm';
let {WizContainer, modelUtils} = framework_tool;
let {WizCard, WizSelect, WizSwitch, WizForm, WizSpin, WizModal, WizButton, WizIcon, WizDropdown, WizMenu, WizTable, WizRadio, WizDatePicker, WizTooltip } = component_tool;
let Item = Form.Item;
let Option = WizSelect.Option;
let {Session} = utils_tool;

class RequirementNoticeDetail extends WizContainer {

  componentName = 'RequirementNoticeDetail';

  constructor(props) {
    super(props);
    const {history} = props;
    let initialValue = {};
    if (history.location && history.location.pathname === '/requirementNotice/requirementNoticeList/requirementNoticeUpd') {
      if (history.location && history.location.record) {
        initialValue = history.location.record;
        Session.set('requirementNoticeDetail', initialValue)
      } else {
        initialValue = Session.get('requirementNoticeDetail') || {};
      }
    }
    this.state = {
      
    };
    this.initialValue = initialValue;
  }

  _componentDidMount() {
    const {history} = this.props;
    if (this.initialValue && this.initialValue.id){
     //this.getRequirementInfo();
    }
  }

  propsAndStateOnChange = {
    addrequirementNotice: this._addrequirementNoticeOver.bind(this),
    updaterequirementNotice: this._updaterequirementNoticeOver.bind(this),
   // requirementNoticeInfo:this._getRequirementInfoOver.bind(this),
  };

  /**
   * 将查询到的新开业培训加载到记录中
   */
  //  _getRequirementInfoOver(nextProps, nextState) {
  //   let requirementNoticeInfo = nextProps.requirementNoticeInfo.data;
  //   const {id} = requirementNoticeInfo;
  //   if (nextProps.requirementNoticeInfo.code == 1 && id && id>0) {
  //     this.initialValue.requirementContents = requirementNoticeInfo.requirementContents;
  //   }else {
  //     this.initialValue.id = null;
  //   }
  //   return true;
  // }

  /**
   * 
   */
  _addrequirementNoticeOver(nextProps, nextState) {
    if (nextProps.addrequirementNotice.code == 1) {
      wizNotice.success('保存成功');
      this.jumpPage('replace', '/requirementNotice/requirementNoticeList');
    } else {
      wizNotice.error('提交失败：' + nextProps.addrequirementNotice.msg);
    }
    return true;
  }

  /**
   * 线下培训班级修改成功返回原页面，失败弹出提示
   */
  _updaterequirementNoticeOver(nextProps, nextState) {
    if (nextProps.updaterequirementNotice.code == 1) {
      wizNotice.success('保存成功');
      this.jumpPage('replace', '/requirementNotice/requirementNoticeList');
    } else {
      wizNotice.error('提交失败：' + nextProps.updaterequirementNotice.msg);
    }
    return true;
  }

  /**获取新开业培训数据 */
  // getRequirementInfo() {
  //   this.doAction({
  //     path: 'requirementNotice/selectOneById',
  //     payload: {
  //       key: 'requirementNotice@selectOneById',
  //       apiParams: {
  //         id: this.initialValue.id,
  //       }
  //     }
  //   });
  // }

  /**
   * 过滤字段值为undefined&null的字段
   * @param fieldsValue
   */
  fitterFieldsValue(fieldsValue) {
    if(this.initialValue.id){
      fieldsValue.id = this.initialValue.id;
    }
    return fieldsValue;
  };

  /**
   * 保存/更新 
   * @param values
   * @private
   */
  _saveRequirement(values) {
    const {history} = this.props;
    let apiPath = "requirementNotice/add";
    let payloadKey = "requirementNotice@add";
    if (history.location && history.location.pathname === '/requirementNotice/requirementNoticeList/requirementNoticeUpd') {
      apiPath = "requirementNotice/update";
      payloadKey = "requirementNotice@update";
    }
    let fitterValues = this.fitterFieldsValue(values);
    if(fitterValues.requirementManager && fitterValues.requirementManager.length && fitterValues.requirementManager.length>5){
      wizNotice.warn("管理员不可超过5人,请确认后重试!");
      return;
    }
    if(fitterValues.anotherNameList && fitterValues.anotherNameList.length && fitterValues.anotherNameList.length>5){
      wizNotice.warn("别名不可超过5个,请确认后重试!");
      return;
    }
    this.doAction({
      path: apiPath,
      payload: {
        key: payloadKey,
        apiParams: {
          ...fitterValues
        }
      }
    });
  };

  _render() {
       return (
         <>
           <WizCard>
           <WizSpin tip={"加载中"} spinning={this.props.requirementNoticeLoading }>
                       <RequirementNoticeForm key = {this.state.ruleId} submit={(v) => { this._saveRequirement(v) }} data={this.initialValue}/>
                   </WizSpin>
           </WizCard>
         </>
       );
     }
}

const mapStateToProps = (state, ownProps) => {
  const {requirementNotice} = state;
  const addrequirementNotice = modelUtils.getModelEntity(requirementNotice, "requirementNotice@add");
  const updaterequirementNotice = modelUtils.getModelEntity(requirementNotice, "requirementNotice@update");
 // const requirementNoticeInfo = modelUtils.getModelEntity(requirementNotice, "requirementNotice@selectOneById");
  const load = modelUtils.getLoadingState(state, ['requirementNotice']);
  return {
    addrequirementNotice: addrequirementNotice,
    updaterequirementNotice: updaterequirementNotice,
   // requirementNoticeInfo: requirementNoticeInfo,
    ...load
  }
};

export default connect(mapStateToProps)(RequirementNoticeDetail);
